module.exports = __webpack_public_path__ + "img/SCC.296f3436.png";